import { SectionOfDashboard } from "./SectionOfDashboard";

export class DashboardTemplate {
  id?: string;
  dashboardTemplateName!: string;
  state!: boolean;
  sectionsOfDashboard!: Array<SectionOfDashboard>;
}
